/**
 * V2TableInternalContext — lightweight internal context used by DynamicTableV2
 * to pass callbacks down to deeply-nested cell renderers without requiring the
 * external DynamicTableContext / withDynamicTableContext HOC.
 *
 * Keep this minimal — only add things that genuinely need to cross the
 * cell-renderer boundary and cannot be passed as props through the render chain.
 */
import { createContext, useContext } from "react";

export interface V2TableInternalContextValue {
  /** Invoked when a modal-type cell is clicked. Mirrors DynamicTableContext.handleShow. */
  handleShow?: (id: unknown, event: unknown, popoverInfo?: unknown) => void;
  /** Axios-like instance passed from the V2 table props for API-dependent renderers. */
  axiosInstance?: { get: Function; post: Function; put?: Function; delete?: Function; request?: Function } | null;
}

export const V2TableInternalContext =
  createContext<V2TableInternalContextValue>({});

export function useV2TableInternal(): V2TableInternalContextValue {
  return useContext(V2TableInternalContext);
}
